import { ConfigActions } from "@redux/reducer";
import store from "@redux/store";
import {
  AuthorUgcType,
  CategoryFilterUgcData,
  CoordinateTagsUgcData,
  DetailProductsUgcType,
  DetailUserType,
  FeaturesType,
  HashtagsType,
  LargeOfficialStylingPayload,
  LargeOfficialStylingUgcPayload,
  LargeStylehintStylingPayload,
  LargeStylehintStylingUgcPayload,
  OfficialListPayload,
  OfficialListUgcPayload,
  ProductCoordinateUgcType,
  ProductDataHandType,
  ProductDetailType,
  ProductModels,
  ProductUgcType,
  RelatedStylingStylehintPayload,
  RelatedStylingStylehintType,
  SBlargeImages,
  SBlargeImagesData,
  SBlargeImagesUgcData,
  SBlargeUgcImages,
  SHlargeImages,
  SHNormalImages,
  SHNormalUgcImages,
  StyleCategoriesTreeType,
  StyleGenderType,
  StylehintListPayload,
  StylehintListUgcPayload,
  StylingDetailType,
  StylingOfficialDetailUgcType,
  SuggestHashtagsUgcType,
  TagCategoriesType,
  UserInfoType,
  UserProfileStyles,
  LANGUAGE,
  ColorListType,
  BRAND_LIST,
  COUNTRY
} from "@type/index";
import {
  getProductCode,
  handleGetGenderValue,
  handleGetUserTypeValue
} from "@util/helpers";

const GetProductColorName = (
  code: string,
  name: string,
  list: ColorListType | null
): string => {
  const { brand_name, region } = store.getState().config;
  if (
    brand_name === BRAND_LIST.UQ &&
    region === COUNTRY.HK &&
    list &&
    list.length > 0
  ) {
    const data = list.find(
      (item) => item.colorNo === code || item.colorNo.includes(code)
    );
    return data?.style || name;
  } else {
    return name;
  }
};

export const OfficialNormalQuery = (
  payload: OfficialListPayload
): OfficialListUgcPayload => {
  const queryParameters: OfficialListUgcPayload = {};
  if (payload.categoryIds !== undefined && payload.categoryIds !== null) {
    queryParameters.style_category_id = payload.categoryIds;
  }
  if (payload.featureIds !== undefined && payload.featureIds !== null) {
    queryParameters.feature_id = payload.featureIds;
  }
  if (payload.tagCodes !== undefined && payload.tagCodes !== null) {
    queryParameters.tag_code = payload.tagCodes;
  }
  if (payload.departmentIds !== undefined && payload.departmentIds !== null) {
    queryParameters.gender_id = payload.departmentIds;
  }
  if (payload.productIds !== undefined && payload.departmentIds !== null) {
    queryParameters.product_id = payload.productIds;
  }
  if (payload.colors !== undefined && payload.colors !== null) {
    queryParameters.colors = payload.colors;
  }
  if (payload.order !== undefined && payload.order !== null) {
    queryParameters.order = payload.order;
  }
  if (payload.limit !== undefined && payload.limit !== null) {
    queryParameters.page_size = payload.limit;
  }
  if (payload.offset !== undefined && payload.offset !== null) {
    queryParameters.page = payload.offset;
  }
  return queryParameters;
};

export const OfficialLargeQuery = (
  payload: LargeOfficialStylingPayload
): LargeOfficialStylingUgcPayload => {
  const queryParameters: LargeOfficialStylingUgcPayload = {};
  if (payload.departmentIds !== undefined && payload.departmentIds !== null) {
    queryParameters.gender_id = payload.departmentIds;
  }
  if (payload.featureIds !== undefined && payload.featureIds !== null) {
    queryParameters.feature_id = payload.featureIds;
  }
  if (
    payload.contentLanguage !== undefined &&
    payload.contentLanguage !== null
  ) {
    queryParameters.content_language = payload.contentLanguage;
  }
  return queryParameters;
};

export const StylehintNormalQuery = (
  payload: StylehintListPayload
): StylehintListUgcPayload => {
  const queryParameters: StylehintListUgcPayload = {};
  if (payload.departmentIds !== undefined && payload.departmentIds !== null) {
    queryParameters.style_gender = payload.departmentIds;
  }
  if (payload.hashTags !== undefined && payload.hashTags !== null) {
    queryParameters.hash_tags = payload.hashTags.split(",");
  }
  if (payload.categoryIds !== undefined && payload.categoryIds !== null) {
    queryParameters.style_category_id = payload.categoryIds
      .split(",")
      .map(Number);
  }
  if (payload.userType !== undefined && payload.userType !== null) {
    queryParameters.user_type = payload.userType;
  }
  if (payload.colors !== undefined && payload.colors !== null) {
    queryParameters.colors = payload.colors.split(",");
  }
  if (payload.unit && payload.unit === "inch") {
    if (
      payload.minModelHeight !== undefined &&
      payload.minModelHeight !== null
    ) {
      queryParameters.min_model_height_inch = payload.minModelHeight;
    }
    if (
      payload.maxModelHeight !== undefined &&
      payload.maxModelHeight !== null
    ) {
      queryParameters.max_model_height_inch = payload.maxModelHeight;
    }
  } else {
    if (
      payload.minModelHeight !== undefined &&
      payload.minModelHeight !== null
    ) {
      queryParameters.min_model_height = payload.minModelHeight;
    }
    if (
      payload.maxModelHeight !== undefined &&
      payload.maxModelHeight !== null
    ) {
      queryParameters.max_model_height = payload.maxModelHeight;
    }
  }
  if (payload.order !== undefined && payload.order !== null) {
    queryParameters.order = payload.order;
  }
  if (payload.productId !== undefined && payload.productId !== null) {
    queryParameters.product_id = payload.productId.split(",");
  }
  if (payload.limit !== undefined && payload.limit !== null) {
    queryParameters.result_limit = payload.limit;
  }
  if (payload.offset !== undefined && payload.offset !== null) {
    queryParameters.page = payload.offset;
  }
  if (payload.userId !== undefined && payload.userId !== null) {
    queryParameters.id_ugc_author_data = payload.userId;
  }
  return queryParameters;
};

export const StylehintRelatedQuery = (
  payload: RelatedStylingStylehintPayload
): StylehintListUgcPayload => {
  const queryParameters: StylehintListUgcPayload = {};
  if (payload.productIds !== undefined && payload.productIds !== null) {
    queryParameters.product_id = payload.productIds.split(",");
  }
  if (payload.departmentIds !== undefined && payload.departmentIds !== null) {
    queryParameters.style_gender = payload.departmentIds;
  }
  if (payload.order !== undefined && payload.order !== null) {
    queryParameters.order = payload.order;
  }
  if (payload.userType !== undefined && payload.userType !== null) {
    queryParameters.user_type = payload.userType;
  }
  if (payload.limit !== undefined && payload.limit !== null) {
    queryParameters.result_limit = payload.limit;
  }
  if (payload.offset !== undefined && payload.offset !== null) {
    queryParameters.page = payload.offset;
  }
  return queryParameters;
};

export const StylehintLargeQuery = (
  payload: LargeStylehintStylingPayload
): LargeStylehintStylingUgcPayload => {
  const queryParameters: LargeStylehintStylingUgcPayload = {};
  if (payload.genderCode !== undefined && payload.genderCode !== null) {
    queryParameters.style_gender = payload.genderCode;
  }
  return queryParameters;
};

export const CategoryFilterMapper = (
  data: Array<CategoryFilterUgcData>
): Array<StyleCategoriesTreeType> => {
  const { language } = store.getState().config;
  const _arr: Array<StyleCategoriesTreeType> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: CategoryFilterUgcData) => {
      const obj: StyleCategoriesTreeType = {};
      obj.id = item.id_ugc_style_category;
      obj.name = item.name;
      obj.localizedName =
        language === LANGUAGE.ENGB ? item.name : item.localized_name;
      obj.styleCount = item.style_count;
      if (item.style_categories && item.style_categories.length > 0) {
        obj.styleCategories = CategoryFilterMapper(item.style_categories);
      }
      _arr.push(obj);
    });
  }
  return _arr;
};

export const CoordinateFilterMapper = (
  data: Array<CoordinateTagsUgcData>
): Array<TagCategoriesType> => {
  const _arr: Array<TagCategoriesType> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: CoordinateTagsUgcData) => {
      const obj: TagCategoriesType = {};
      obj.code = item.tag_code;
      obj.name = item.tag_name;
      obj.totalStyles = item.total_styles;
      obj.displayCode = item.tag_display_code;
      _arr.push(obj);
    });
  }
  return _arr;
};

export const FeatureFilterMapper = (
  data: SBlargeImagesUgcData
): Array<FeaturesType> => {
  const _arr: Array<FeaturesType> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: SBlargeUgcImages) => {
      const obj: FeaturesType = {};
      obj.id = item.feature_id;
      obj.title = item.title;
      _arr.push(obj);
    });
  }
  return _arr;
};

export const HashtagFilterMapper = (
  data: Array<SuggestHashtagsUgcType>
): Array<HashtagsType> => {
  const _arr: Array<HashtagsType> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: SuggestHashtagsUgcType) => {
      const obj: HashtagsType = { hashtag: "" };
      obj.hashtag = item.hashtag || "";
      _arr.push(obj);
    });
  }
  return _arr;
};

export const FeatureLargeImgMapper = (
  data: SBlargeImagesUgcData
): SBlargeImagesData => {
  const _arr: SBlargeImagesData = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: SBlargeUgcImages) => {
      const obj: SBlargeImages = {
        featureId: "",
        imageUrl: "",
        title: "",
        description: ""
      };
      obj.featureId = item.feature_id;
      obj.imageUrl = item.feature_img_url;
      obj.title = item.title;
      obj.description = item.description;
      _arr.push(obj);
    });
  }
  return _arr;
};

export const HashtagLargeImgMapper = (
  data: Array<SuggestHashtagsUgcType>
): Array<SHlargeImages> => {
  const _arr: Array<SHlargeImages> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: SuggestHashtagsUgcType) => {
      const obj: SHlargeImages = {};
      obj.order = item.order;
      obj.hashtag = item.hashtag;
      obj.outfitId = item.outfit_id;
      obj.imageUrl = item.image_url;
      obj.description = item.description;
      obj.createdAt = Number(item.created_at);
      obj.updatedAt = Number(item.updated_at);
      obj.styleGender = item.style_gender as StyleGenderType;
      _arr.push(obj);
    });
  }
  return _arr;
};

export const StylingOfficialDetailMapper = (
  obj: StylingOfficialDetailUgcType,
  products: Array<ProductDataHandType>
): StylingDetailType => {
  const _arr: Array<ProductModels> = [];
  if (obj.coordinate && obj.coordinate.length > 0) {
    obj.coordinate.forEach((item: ProductCoordinateUgcType) => {
      const _obj: ProductModels = { products: [] };
      _obj.positionId = item.position_id;
      _obj.positionName = item.position_name;
      _obj.products =
        item.products && item.products.length > 0
          ? ProductSBDataMapper(item.products, products)
          : [];
      _arr.push(_obj);
    });
  }
  return {
    styleImageUrl: obj.style.image_original,
    models: _arr
  };
};

export const ProductSBDataMapper = (
  data: Array<ProductUgcType>,
  products: Array<ProductDataHandType>
): Array<ProductDetailType> => {
  const _arr: Array<ProductDetailType> = [];
  const arr = JSON.parse(JSON.stringify(data));
  arr.forEach((item: ProductUgcType) => {
    const _product: ProductDataHandType | undefined = products.find(
      (p: ProductDataHandType) => {
        const code = getProductCode(item.product_link);
        const isApproval =
          p.approval === "LIST" ||
          p.approval === "AUTOLIST" ||
          p.approval === "BEGINLIST";
        return (
          (p.productCode === code || p.code === item.product_id) &&
          p.enabledFlag === "Y" &&
          isApproval
        );
      }
    );
    if (_product) {
      const _obj: ProductDetailType = {
        l2Id: "",
        productName: "",
        productId: "",
        flags: {
          productFlags: [],
          priceFlags: []
        },
        stockStatus: "",
        price: {
          maxPrice: "",
          minPrice: ""
        },
        genderCategory: "",
        pdpImageUrl: "",
        color: {
          name: "",
          code: "",
          displayCode: ""
        },
        size: "",
        productCode: ""
      };
      _obj.box = [];
      _obj.pdpImageUrl = item.image_url;
      _obj.color.name = GetProductColorName(
        item.color_code,
        item.color_name,
        _product.colorList
      );
      _obj.color.code = item.color_code;
      _obj.color.displayCode = item.display_color_code;
      _obj.size = "";
      _obj.l2Id = item.im_name || "";
      _obj.productName = _product.name || "";
      _obj.productId = _product.code || "";
      _obj.flags = {
        productFlags: [],
        priceFlags: []
      };
      _obj.stockStatus = _product.hasStock;
      _obj.price = {
        maxPrice: _product.maxPrice,
        minPrice: _product.minPrice
      };
      _obj.genderCategory = _product.sex || "";
      _obj.productCode =
        item.product_link.length > 0 ? getProductCode(item.product_link) : "";
      _arr.push(_obj);
    }
  });
  return _arr;
};

export const isFromInstagram = (source: string) =>
  source === "olapic" ||
  source === "shuttlerock" ||
  source === "instagram" ||
  source === "instagram_business";

export const StylingStylehintDetailMapper = (
  obj: SHNormalUgcImages,
  products: Array<ProductDataHandType>
): StylingDetailType => {
  const imageSource = obj.author?.image_source || "";
  const fromInstagram = isFromInstagram(imageSource);
  const _user: DetailUserType = {
    brand: obj.author.store_info.brand_name,
    comment: obj.description,
    height: obj.author.user_height,
    id: obj.author.id_ugc_author_data,
    image: obj.author.picture_url,
    isFromInstagram: fromInstagram,
    name: fromInstagram ? obj.author.user_name : obj.author.nick_name,
    region: obj.author.store_info.region_name,
    storeId: obj.author.store_info.store_id,
    storeName: obj.author.store_info.store_name,
    userType: handleGetUserTypeValue(obj.author.user_type || 0),
    validatedDate: Date.parse(obj.updated_date)
  };

  return {
    gender: obj.gender,
    hashtags: obj.hash_tags,
    last7DaysLikes: obj.ec_info.like_7days_delta,
    modelHeight: obj.model_height,
    models: [
      {
        products:
          obj.products && obj.products.length > 0
            ? ProductSHDataMapper(obj.products, products)
            : []
      }
    ],
    publishedAt: Number(obj.ugc_published_at),
    styleImageUrl: obj.image_original,
    totalLikes: obj.ec_info.like_total,
    userInfo: _user,
    postTag: obj.post_tag
  };
};

export const ProductSHDataMapper = (
  data: Array<DetailProductsUgcType>,
  products: Array<ProductDataHandType>
): Array<ProductDetailType> => {
  const _arr: Array<ProductDetailType> = [];
  const arr = JSON.parse(JSON.stringify(data));
  arr.forEach((item: DetailProductsUgcType) => {
    const _product: ProductDataHandType | undefined = products.find(
      (p: ProductDataHandType) => {
        const code = getProductCode(item.ugc_item.product_link);
        const isApproval =
          p.approval === "LIST" ||
          p.approval === "AUTOLIST" ||
          p.approval === "BEGINLIST";
        return p.productCode === code && p.enabledFlag === "Y" && isApproval;
      }
    );
    if (_product) {
      const _obj: ProductDetailType = {
        l2Id: "",
        productName: "",
        productId: "",
        flags: {
          productFlags: [],
          priceFlags: []
        },
        stockStatus: "",
        price: {
          maxPrice: "",
          minPrice: ""
        },
        genderCategory: "",
        pdpImageUrl: "",
        color: {
          name: "",
          code: "",
          displayCode: ""
        },
        size: "",
        productCode: ""
      };
      _obj.box = item.box_normalized;
      _obj.pdpImageUrl = item.ugc_item.image_url;
      _obj.color.name = item.ugc_item.fr_color_name;
      _obj.color.code = "";
      _obj.color.displayCode = item.ugc_item.display_color_code;
      _obj.size = item.ugc_item.item_size;
      _obj.l2Id = item.ugc_item.im_name || "";
      _obj.productName = _product.name || "";
      _obj.productId = _product.code || "";
      _obj.flags = {
        productFlags: [],
        priceFlags: []
      };
      _obj.stockStatus = _product.hasStock;
      _obj.price = {
        maxPrice: _product.maxPrice,
        minPrice: _product.minPrice
      };
      _obj.genderCategory = _product.sex || "";
      _obj.productCode =
        item.ugc_item.product_link.length > 0
          ? getProductCode(item.ugc_item.product_link)
          : "";
      _arr.push(_obj);
    }
  });
  return _arr;
};

export const ContentSearchMapper = (
  data: Array<SHNormalUgcImages>
): Array<SHNormalImages> => {
  const _arr: Array<SHNormalImages> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: SHNormalUgcImages) => {
      const obj: SHNormalImages = {};
      obj.outfitId = item.id_ugc_dist_content.toString();
      obj.styleImageUrl = item.image_original;
      obj.isFromInstagram = isFromInstagram(item.source_network);
      obj.originalSourceUrl = item.link_to_url;
      obj.departmentId = handleGetGenderValue(item.gender).toLowerCase();
      obj.totalLikes = item.ec_info.like_total;
      obj.last7DaysLikes = item.ec_info.like_7days_delta;
      _arr.push(obj);
    });
  }
  return _arr;
};

export const StylehintRelatedMapper = (
  data: Array<SHNormalUgcImages>
): Array<RelatedStylingStylehintType> => {
  const _arr: Array<RelatedStylingStylehintType> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: SHNormalUgcImages) => {
      const obj: RelatedStylingStylehintType = {
        id: 0
      };
      const imageSource = item.author.image_source || "";
      const fromInstagram = isFromInstagram(imageSource);
      obj.last7DaysLikes = item.ec_info.like_7days_delta;
      obj.totalLikes = item.ec_info.like_total;
      obj.id = item.id_ugc_dist_content;
      obj.image = item.image_original;
      obj.userInfo = {
        image: item.author.picture_url,
        name: fromInstagram ? item.author.user_name : item.author.nick_name,
        height: item.author.user_height, //cm
        isFromInstagram: fromInstagram,
        userType: handleGetUserTypeValue(item.author.user_type || 0),
        storeName: item.author.store_info.store_name,
        brand: item.author.store_info.brand_name,
        region: item.author.store_info.region_name,
        storeId: item.author.store_info.store_id,
        id: item.author.id_ugc_author_data
      };
      obj.gender = handleGetGenderValue(item.gender).toLowerCase();
      obj.modelHeight = item.model_height;
      _arr.push(obj);
    });
  }
  return _arr;
};

export const UserInfoMapper = (data: AuthorUgcType): UserInfoType => {
  const obj: UserInfoType = {
    bio: "",
    brand: "",
    height: 0,
    id: 0,
    isFromInstagram: false,
    name: "",
    region: "",
    storeId: 0,
    storeName: "",
    storeOrgCode: "",
    userType: "CONSUMER"
  };
  const imageSource = data.image_source || "";
  const fromInstagram = isFromInstagram(imageSource);
  obj.bio = data.user_bio;
  obj.brand = data.store_info.brand_name;
  obj.height = data.user_height;
  obj.id = data.id_ugc_author_data;
  obj.image = data.picture_url;
  obj.isFromInstagram = fromInstagram;
  obj.name = fromInstagram ? data.user_name : data.nick_name;
  obj.region = data.store_info.region_name;
  obj.storeId = data.store_info.store_id;
  obj.storeName = data.store_info.store_name;
  obj.storeOrgCode = data.store_info.org_code;
  obj.userType = handleGetUserTypeValue(data.user_type || 0);
  return obj;
};

export const UserStylingListMapper = (
  data: Array<SHNormalUgcImages>
): Array<UserProfileStyles> => {
  const _arr: Array<UserProfileStyles> = [];
  const arr = JSON.parse(JSON.stringify(data));
  if (arr.length > 0) {
    arr.forEach((item: SHNormalUgcImages) => {
      const obj: UserProfileStyles = {
        id: 0,
        last7DaysLikes: 0,
        modelHeight: 0,
        originalSourceUrl: "",
        styleImageUrl: "",
        totalLikes: 0
      };
      obj.id = item.id_ugc_dist_content;
      obj.isFromInstagram = isFromInstagram(item.source_network);
      obj.last7DaysLikes = item.ec_info.like_7days_delta;
      obj.modelHeight = item.model_height;
      obj.originalSourceUrl = item.link_to_url;
      obj.styleImageUrl = item.image_original;
      obj.totalLikes = item.ec_info.like_total;
      _arr.push(obj);
    });
  }
  return _arr;
};

const validateQueryParam = (
  paramName: string, // Url parameter name (such as "featureId" or "coordinate")
  getFilteredList: (arr: string[]) => string[]
) => {
  const {
    urlParams: urlSearchValue,
    globalCounter,
    urlTotalParams,
    urlChange
  } = store.getState().config;
  const urlParams = new URLSearchParams(urlSearchValue);

  // Check whether the parameter exists
  if (urlParams.has(paramName)) {
    let hasChange = false;
    // Counter to determine whether all parameters have been validated
    const count = globalCounter + 1;
    store.dispatch(ConfigActions.setGlobalCounter(count));

    const paramValue = urlParams.get(paramName);
    const paramArray = paramValue ? paramValue.split(",") : [];

    // Filter out values that do not exist in the list
    const filteredArray = getFilteredList(paramArray);

    // If the filtered array is different from the original array, there are missing values
    if (filteredArray.length !== paramArray.length) {
      // If the filtered array is empty, delete this parameter
      if (filteredArray.length === 0) {
        urlParams.delete(paramName);
      } else {
        // Update the value of this parameter
        urlParams.set(paramName, filteredArray.join(","));
      }
      store.dispatch(ConfigActions.setUrlParams(urlParams.toString()));
      store.dispatch(ConfigActions.setUrlChange(true));
      hasChange = true;
    }

    if (count === urlTotalParams && (urlChange || hasChange)) {
      // Rebuild the new URL (replace only the current parameters)
      const newUrl = `${window.location.origin + window.location.pathname}${
        urlParams.toString()
          ? `?${decodeURIComponent(urlParams.toString())}`
          : ""
      }`;
      // Refresh the page
      window.location.href = newUrl;
    }
  }
};

// Check feature
export const checkFeatureCode = (featureList: Array<FeaturesType>) => {
  validateQueryParam("featureId", (arr: string[]) =>
    arr.filter((item: string) =>
      featureList.some((obj: FeaturesType) => obj.id === item)
    )
  );
};

// Check coordinate
export const checkCoordinate = (coordinateList: Array<TagCategoriesType>) => {
  validateQueryParam("coordinate", (arr: string[]) =>
    arr.filter((item: string) =>
      coordinateList.some((obj: TagCategoriesType) => obj.code === item)
    )
  );
};
